var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('LoadingSpinnerV2'):_vm._e(),_vm._v(" "),_c('AskOrganiserFormV2',{staticStyle:{"padding":"var(--e4s-gap--standard)"},attrs:{"competition-summary-public":_vm.competitionSummaryPublic},on:{"cancel":_vm.cancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }